import Header from '../components/Header/Header'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { toggleMobileMenu } from '../modules/settings'

const mapStateToProps = (state, props) => ({
  openMobileMenu: state.settings.openMobileMenu
})

const mapDispatchToProps = dispatch => bindActionCreators({
  toggleMobileMenu
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Header)



// WEBPACK FOOTER //
// ./src/containers/HeaderContainer.js